import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddActionComponent } from '../add-action/add-action.component';
import { EditActionComponent } from '../edit-action/edit-action.component';
import { BehaviorSubject } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrl: './action.component.scss'
})
export class ActionComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  actionData: any = [];
  validationform: UntypedFormGroup;
  modalRef: NgbModalRef | null = null;

  itemToDelete!: any;
  paginatedProjets = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  filteredData: any[] = [];
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,

  ) {
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.fetchDataAction();
    });
  }

  ngOnInit(): void {
  }

  fetchDataAction() {
    this.isLoading === false;
    this.paramservice.fetchDataAction().subscribe(
      (response: any) => {
        this.actionData = response.data;
        this.filteredData = [...this.actionData];
        this.totalRecords = this.filteredData.length;
        this.updatePaginatedProjets();
        this.isLoading = true;
        //console.log("this.actionData", this.actionData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredData.slice(start, end);
  }


  filterData() {
  const lowerSearchTerm = this.searchTerm.toLowerCase();

  if (!lowerSearchTerm.trim()) {
    this.filteredData = [...this.actionData];
  } else {
    const searchWords = lowerSearchTerm.split(' ').filter(w => w);

    this.filteredData = this.actionData.filter((item: any) => {
      const libelle = item.libelle?.toLowerCase() || "";
      const direction = item.direction_id?.toLowerCase?.() || ""; // si direction est string

      return searchWords.every(word =>
        libelle.includes(word) ||
        direction.includes(word)
      );
    });
  }

  // mise à jour pagination
  this.totalRecords = this.filteredData.length;
  this.firstProjets = 0;
  this.updatePaginatedProjets();
}
  openModal() {
    this.modalService.open(AddActionComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'

    });
  }

  EditModal(action: any) {
    //console.log("action",action);
    
    this.localstorage.saveAction(action)
    const modalRef = this.modalService.open(EditActionComponent, {
      backdrop: 'static',
      size: 'xl',
      centered: true,
    },);
  }

  confirmSuppression(event: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette action ' + event.libelle + '?',

      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteAction(event.reference).subscribe(
          (response: any) => {
            //console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'succes', summary: Constant.suiviTitle, detail: response.message });
            this.fetchDataAction();
            this.ngxService.stop();

          },
          (error) => {
            //console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'warn', summary: Constant.suiviTitle, detail: error });
            this.ngxService.stop();
          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      // }
    });
  }



}
export class ActionServiceService {
  private ActionCreatedSubject = new BehaviorSubject<boolean>(false);
  actionCreated$ = this.ActionCreatedSubject.asObservable();

  notifyProgrammeCreated() {
    this.ActionCreatedSubject.next(true);
  }
} 